import {
  CLEAR_SOUND_EFFECT_CATEGORY,
  CLEAR_SOUND_EFFECT_SEARCH,
  SELECT_SOUND_EFFECT_CATEGORY,
  SET_SOUND_EFFECT_TERM,
} from '@App/store/actions/soundEffect';

export interface SoundEffectState {
  /** Submitted text term. Empty means "no text criterion", not "no results": see the page. */
  term: string
  /** Active `ucsCatId` filter, or null. */
  catId: string | null
  /** Human label of the active category, shown as a chip in the search bar. */
  catLabel: string | null
}

const initialState: SoundEffectState = {
  term: '',
  catId: null,
  catLabel: null,
};

/**
 * Sound effects search criteria (/effets-sonores).
 *
 * Shared state rather than page state: the search box lives in the fixed header (so it survives
 * scrolling and cannot cover the account dropdown), the category column and the result list live in
 * the page. All three read and write here.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function soundEffect(state = initialState, action): any {
  const { type, payload } = action;

  switch (type) {
    case SET_SOUND_EFFECT_TERM:
      return { ...state, term: payload.term };

    case SELECT_SOUND_EFFECT_CATEGORY:
      return { ...state, catId: payload.id, catLabel: payload.label };

    case CLEAR_SOUND_EFFECT_CATEGORY:
      return { ...state, catId: null, catLabel: null };

    case CLEAR_SOUND_EFFECT_SEARCH:
      return initialState;

    default:
      return state;
  }
}
